module.exports = __webpack_public_path__ + "static/media/Pan.c752d5fb.svg";